export default __webpack_public_path__ + "97dfa0a8132930f5c4dd56b2f19e11b9.png";